const maruyaApiUrl = import.meta.env.VITE_MARUYA_API_URL?.trim() ?? ''

/** @deprecated VITE_MARUYA_API_URL を使用してください */
const legacyApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim() ?? ''

const apiBaseUrl = maruyaApiUrl || legacyApiBaseUrl

export const env = {
  /** maruya-api BFF のベース URL */
  maruyaApiUrl: apiBaseUrl,
  /** @deprecated maruyaApiUrl を使用 */
  apiBaseUrl,
  isApiConfigured: apiBaseUrl.length > 0,
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID?.trim() ?? '',
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID?.trim() ?? '',
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION?.trim() ?? 'ap-northeast-1',
} as const
